import P from '@hero/ui-kit/typography/P';
import React from 'react';
import type { ParagraphBlock as ParagraphBlockType } from '../../../types';
import renderTextWithVariables from '../renderTextWithVariables';

const ParagraphBlock: React.FC<{ block: ParagraphBlockType }> = ({ block }) => (
    // BE paragraph.html renders class="mark-<style>" with "body" as the default.
    <P className={`mark-${block.style || 'body'}`} styles={{ margin: '0.4rem 0', lineHeight: 1.6 }}>
        {renderTextWithVariables(block.text)}
    </P>
);
export default ParagraphBlock;
